module.exports = __webpack_public_path__ + "static/img/logo.3b66206.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpeg
// module id = 8JcL
// module chunks = 1